import { styled, Text, TokenTextAppearance, } from "@volkswagen-onehub/components-core";
import * as React from "react";
import { Link as StandardLink } from "../component/Link";
import { useQuery } from "@apollo/client";
import { dashboard } from "../queries/dashboard";
import { gql } from "../../__generated__/gql";
import { breakpoints } from "@volkswagen-onehub/tokens";
const CardsContainer = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2em;
  margin: 0 10%;
  @media (max-width: ${breakpoints.b560}px) {
    margin: 0 2%;
  }
`;
const Card = styled.div `
  min-width: 150px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-start;
  padding: 15px;
  border: grey 1px solid;
  position: relative;
`;
const Headline = (props) => (React.createElement(Text, { appearance: TokenTextAppearance.headline300, bold: true },
    React.createElement(StandardLink, { ...props })));
const Stats = styled.div `
  position: absolute;
  font-size: 5vw;
  color: grey;
  bottom: 2px;
  right: 0.2em;
`;
const dashboardQuery = gql(dashboard);
export const DashboardView = () => {
    const { data } = useQuery(dashboardQuery);
    let marketCount;
    let bundleVersion;
    let envCount;
    let faStat;
    let configuredFeatureApps;
    if (data) {
        const featureAppCount = data.featureAppDashboard?.prod;
        faStat = `${featureAppCount?.deploymentSet} / ${featureAppCount?.featureApp}`;
        marketCount = data.markets[0].markets?.length;
        bundleVersion = data.bundle.servers
            ?.filter((s) => s.name === "prod")
            .map((s) => (s.serviceBundle ? s.serviceBundle.version : ""))[0];
        envCount = 3;
        configuredFeatureApps = data.omIntegratorConfig.featureAppConfigurations;
    }
    return (React.createElement(CardsContainer, null,
        React.createElement(Card, null,
            React.createElement(Headline, { path: "/server", text: "Environments" }),
            React.createElement(StandardLink, { path: "/server/prod", text: "Production" }),
            React.createElement(StandardLink, { path: "/server/stage", text: "Stage" }),
            React.createElement(StandardLink, { path: "/server/int", text: "Integration" }),
            React.createElement(Stats, null, envCount)),
        React.createElement(Card, null,
            React.createElement(Headline, { path: "/featureapp", text: "Feature Apps" }),
            React.createElement(Stats, null, faStat)),
        React.createElement(Card, null,
            React.createElement(Headline, { path: "/apps", text: "Plugins" }),
            configuredFeatureApps?.slice(0, 3).map((featureApp) => (React.createElement(StandardLink, { key: featureApp.name, path: `/apps/${encodeURIComponent(featureApp.name)}`, text: "AI Efficiency Booster" }))),
            React.createElement(Stats, null, configuredFeatureApps?.length)),
        React.createElement(Card, null,
            React.createElement(Headline, { path: "/server/prod/market", text: "Markets" }),
            React.createElement(StandardLink, { path: "/server/stage/market", text: "Stage" }),
            React.createElement(StandardLink, { path: "/server/int/market", text: "Integration" }),
            React.createElement(Stats, null, marketCount),
            " "),
        React.createElement(Card, null,
            React.createElement(Headline, { path: "/serviceBundle", text: "Feature Service Bundle" }),
            React.createElement(Stats, null, bundleVersion),
            " ")));
};
